import {Action} from "@ngrx/store";
import {ISubscription} from "@retail-data-factory/rdf-angular-types-api";

export enum EMarketplaceActions {
  LoadSubscriptions = '[Marketplace] Load Subscriptions',
  LoadSubscriptionsSuccess = '[Marketplace] Load Subscriptions Success',
  LoadSubscriptionsFailure = '[Marketplace] Load Subscriptions Failure'
}
export class LoadSubscriptions implements Action {
  public readonly type = EMarketplaceActions.LoadSubscriptions;
}

export class LoadSubscriptionsSuccess implements Action {
  public readonly type = EMarketplaceActions.LoadSubscriptionsSuccess;
  constructor(public payload: Array<ISubscription>){}
}
export class LoadSubscriptionsFailure implements Action {
  public readonly type = EMarketplaceActions.LoadSubscriptionsFailure;
}

export type MarketplaceActions =
  LoadSubscriptions |
  LoadSubscriptionsSuccess |
  LoadSubscriptionsFailure;

/*
export class GetAccountsSuccess implements Action {
  public readonly type = EAccountingActions.GetAccountsSuccess;
  constructor(public payload: Array<IAccount>){}
}
export class GetAccountsFailure implements Action {
  public readonly type = EAccountingActions.GetAccountsFailure;
}
 */
